import { observable, action, computed } from "mobx";
import { findIndex } from "lodash";
import { ConsultantEditorStore } from "../../ConsultantEditorStore";
import {
  ExpertiseProfession,
  ExpertiseProfessionStore
} from "../ExpertiseProfessionStore";
import { ExpHelper } from "../Common/ExpHelper";

export interface OnlyExperienceProfession extends ExpertiseProfession {
  specializations: Specialization[];
}

export interface Specialization {
  name: string;
  yearFrom: string;
  interested: boolean;
  comment: string;
  qualified: boolean;
}

export class OnlyExperienceStore extends ExpertiseProfessionStore<OnlyExperienceProfession> {
  @observable selectedSpecialization: string[];

  constructor(
    profession: string,
    storeIndex: number,
    public editorStore: ConsultantEditorStore
  ) {
    super(profession, storeIndex, editorStore);
    this.selectedSpecialization = null;
  }

  initForm() {
    if (!this.currentExpertiseProfession) {
      this.editorStore.form.setValue(`professions.${this.storeIndex}`, {
        professionName: this.profession,
        specializations: []
      });
    }
  }

  get specializations(): Specialization[] {
    return this.currentExpertiseProfession?.specializations ?? [];
  }

  get methods(): string[] {
    return this.editorStore.getMethodsOnProfession(this.profession);
  }

  private get selectAoEList() {
    return this.editorStore.getAOEsOnProfession(this.profession);
  }

  get selectSpecializationList() {
    return ExpHelper.uniqFlatten<string>(
      this.selectAoEList.map((x) =>
        this.editorStore.getSpecialization(x, this.profession)
      )
    ).filter((x) => !this.specializations.any((y) => y.name === x));
  }

  @computed get selectedMethods(): string[] {
    return this.editorStore.form.values.expertise?.[this.storeIndex].methods || [];
  }

  @action setSelectedSpecialization = (val: string[]) => {
    this.selectedSpecialization = val;
  };

  @action addMethods = (items: string[]) => {
    this.editorStore.form.setValue(`expertise.${this.storeIndex}.methods`, items);
  };

  addSpec = () => {
    this.selectedSpecialization.map((x) => {
      const i = findIndex(this.specializations, (a) => a.name === x);
      if (i === -1) {
        super.addSpec<Specialization>({
          name: x,
          yearFrom: "",
          interested: true,
          qualified: true,
          comment: ""
        });
      }
    });
    this.setSelectedSpecialization(null);
  };

  @action removeSpec = (path: string, i: number) => {
    this.editorStore.form.removeByIndex(path, i);
  };
}
